import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pem',
    standalone: false
})
export class PemPipe implements PipeTransform {
    transform(pem: string) {
        return pem
            .replace(/-----BEGIN[A-Z ]+-----/, '')
            .replace(/-----END[A-Z ]+-----/, '')
            .replace('\n', '')
            .trim();
    }
}
